var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-edit-workload-version',{staticClass:"pt-6 pl-6"})
}
var staticRenderFns = []

export { render, staticRenderFns }